<template>
  <div class="form1">
    <div class="page_form">
      <div class="form_title">页面设置</div>
      <el-form label-width="200px">
        <el-form-item label="活动名称">
          <el-input class="input_box" v-model="pageForm.name"></el-input>
        </el-form-item>
        <el-form-item label="活动时间">
          <el-date-picker
            v-model="pageForm.time"
            type="datetimerange"
            range-separator="至"
            @change="handleTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            :default-time="['00:00:00', '23:59:59']"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动模板" v-if="false">
          <div class="module_box">
            <div class="module_item" v-for="(item,index) in moduleList" :key="index" :class="{select_item: item.select}" @click="selectModule(index)"></div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="page_form">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="高级选项" name="1">
          <el-form label-width="200px">
            <el-form-item label="活动规则">
              <el-radio v-model="advancedForm.rule" label="0">默认</el-radio>
              <el-radio v-model="advancedForm.rule" label="1">自定义</el-radio>
              <!-- <div>
                <el-input class="input_box" type="textarea"></el-input>
              </div> -->
              <div v-show="advancedForm.rule == '0'">
                <el-input class="input_box" type="textarea" rows="13" disabled v-model="defaultRule"></el-input>
              </div>
              <div v-show="advancedForm.rule == '1'">
                <el-input class="input_box" type="textarea" rows="13" v-model="pageForm.rule"></el-input>
              </div>
            </el-form-item>
            <!-- <el-form-item label="授权限制">
              <el-checkbox v-model="advancedForm.auth_mobile">授权手机号</el-checkbox>
              <el-checkbox v-model="advancedForm.auth_user">授权用户信息</el-checkbox>
            </el-form-item> -->
            <el-form-item label="分享标题">
              <el-radio v-model="advancedForm.title_type" label="0">默认</el-radio>
              <el-radio v-model="advancedForm.title_type" label="1">自定义</el-radio>
              <div v-show="advancedForm.title_type == '0'">
                <el-input class="input_box" disabled v-model="defaultTitle"></el-input>
              </div>
              <div v-show="advancedForm.title_type == '1'">
                <el-input class="input_box" v-model="pageForm.title"></el-input>
              </div>
              <!-- <el-input class="input_box" v-model="pageForm.title"></el-input> -->
            </el-form-item>
            
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-form label-width="200px">
      <el-form-item>
        <div style="margin-top: 30px">
          <el-button @click="goBack()">返回</el-button>
          <el-button type="primary" @click="nextStep()">下一步</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(["token", "app_id", "inviteForm"])
  },
  data(){
    return{
      activeNames: ["1"],
      pageForm: {
        name: "",
        time: [],
        module: 0,
        title: "",
        rule: "",
      }, // 页面设置
      advancedForm: {
        rule: "0",
        auth_mobile: true,
        auth_user: true,
        title_type: "0",
        title: ""
      }, // 高级设置
      moduleList: [{select: true},{select: false},{select: false}],
      defaultTitle: "「分享人手机尾号」送您「配置的奖励」元加油礼包",
      defaultRule: `1.活动时间：「根据设置自动生成」
2.邀请人资格：「根据设置自动生成」
3.邀请成功条件：「根据设置自动生成」
4.邀请成功奖励：「根据设置自动生成」
5.阶梯奖励：「根据设置自动生成，无设置不显示」
6.被邀人资格：「根据设置自动生成」
7.被邀人奖励：「根据设置自动生成」
其他规则说明：
a.若同一用户被多人邀请或被多个活动邀请，则只返一次奖，且返奖给对应的邀请方。
b.同一账号、手机号、身份证、手机终端，符合以上任一条件均视为同一用户。
c.如发现用户存在恶意刷取奖励、非本人意愿领取奖励、机器模拟等恶意行为，您将无法获得奖励`
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    init(){
    },
    nextStep(){
      var newData = {
        name: this.pageForm.name,
        start_time: this.pageForm.time[0],
        end_time: this.pageForm.time[1],
        rule: this.pageForm.rule,
        title: this.pageForm.title
      }
      this.$store.commit('SET_INVITEFORM',newData);
      this.$emit('nextStep')
    },
    selectModule(i){
      this.moduleList.forEach((item,index) => {
        if(i == index) {
          item.select = true;
        }else{
          item.select = false;
        }
      })
    },
    goBack(){
      this.$router.go(-1)
    },
    handleTime(val){
      console.log(val)
    }
  }
}
</script>
<style lang="scss" scoped>
.page_form{
  margin-top: 20px;
  .form_title{
    border-top: 1px solid #EBEEF5;
    // border-bottom: 1px solid #EBEEF5;
    line-height: 47px;
    color: #303133;
    font-size: 13px;
    margin-bottom: 20px;
  }
  .input_box{
    width: 520px;
  }
  .module_box{
    display: flex;
    padding-bottom: 10px;
    .module_item{
      margin-right: 12px;
      border: 2px solid #ddd;
      border-radius: 4px;
      width: 140px;
      height: 90px;
    }
    .select_item{
      border: 2px solid #409eff !important;
    }
  }
}
</style>